export default __webpack_public_path__ + "static/media/ic_deskera.0583b457.png";